import React from "react";
import { Box, Button, CircularProgress, Collapse } from "@vapor/react-material";

const LoadingComponent = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress
        size={"40px"}
        color="primary"
        style={{ marginTop: 18 }}
      />
    </div>
  );
};

export default LoadingComponent;
